import React from 'react';
const tomes = [{
  number: '01',
  title: 'Sistema de Primera Consulta',
  desc: 'De la anamnesis al plan en 60 minutos. Protocolo completo listo para usar.'
}, {
  number: '02',
  title: '30 Planes Listos para Personalizar',
  desc: 'Planes por patología con ficha de personalización por edad, peso y nivel socioeconómico.'
}, {
  number: '03',
  title: 'Educación Alimentaria Lista',
  desc: 'Láminas, infografías y material profesional para entregar en cada consulta.'
}, {
  number: '04',
  title: 'Paciente que Vuelve',
  desc: 'Sistema de seguimiento, adherencia y retención de pacientes a largo plazo.'
}, {
  number: '05',
  title: '100 Recetas Clínicas',
  desc: 'El recetario que tus pacientes van a guardar. Adaptado al contexto alimentario argentino.'
}, {
  number: '06',
  title: 'Nutricionista de Alto Valor',
  desc: 'El sistema para que tu consultorio crezca solo. Honorarios, marca y rentabilidad.'
}];
const includes = ['Protocolos listos para usar desde hoy', 'Material imprimible para entregar al paciente', 'Checklists de seguimiento por consulta', 'Planes adaptables por patología y perfil', 'Scripts de comunicación con pacientes', 'Planificación mensual y por objetivo'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(240,253,244) 15%, rgb(240,253,244) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-350">
      <div className="mx-auto max-w-4xl" data-id="element-351">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-352">
          Lo que <span className="text-green-700" data-id="element-353">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-354">
          6 tomos · +400 páginas · Todo listo para implementar hoy
        </p>

        {/* Tomos */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-355">
          {/* Header */}
          <div className="bg-green-700 px-5 py-3" data-id="element-356">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-357">
              🥑 LOS 6 TOMOS — Sistema Clínico Completo para Nutricionistas
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-358">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-359">
                {/* Número */}
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-360">
                  {tome.number}
                </span>

                {/* Contenido */}
                <div className="flex-1 min-w-0" data-id="element-361">
                  <span className="block text-sm font-black text-gray-900" data-id="element-362">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-363">
                    {tome.desc}
                  </span>
                </div>

                {/* Páginas */}
                <span className="shrink-0 text-[10px] font-bold text-green-700 bg-green-700/5 border border-green-700/20 rounded-full px-2 py-0.5" data-id="element-364">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm" data-id="element-365">
          {/* Header */}
          <div className="bg-green-700/5 border-b border-green-700/20 px-5 py-3" data-id="element-366">
            <h3 className="text-sm font-black text-green-700 m-0" data-id="element-367">
              Cada tomo incluye:
            </h3>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-368">
            {includes.map((item, i) => <div key={item} className={`flex items-start gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''}`} data-id="element-369">
                <span className="shrink-0 text-green-700 font-bold text-sm mt-0.5" data-id="element-370">
                  ✅
                </span>
                <span className="text-xs text-gray-700 leading-5" data-id="element-371">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}